import { CardDeckServer, CreateCardDeckServerData } from "@olagg/db-types"
import { AdminCardDecksServersEndpoints } from "../endpoints/adminEndpoints"
import { fetcher } from "../fetcher"
import { useToast } from "@chakra-ui/react"
import { useQ } from "./useQ"
import { useState } from "react"

export const useAdminCardDecksServers = (deckId: string | number) => {
  const toast = useToast();
  const [server, setServer] = useState<CardDeckServer>();

  const response = useQ<{discordServers: CardDeckServer[]}>(AdminCardDecksServersEndpoints.list(deckId));

  const success_toast = (description: string) => {
    toast({
      title: 'Servidor de Discord',
      colorScheme: 'olaggPink',
      status: 'success',
      description,
      position: 'bottom-right'
    });
  }
  
  const error_toast = (error: any) => {
    toast({
      title: 'Error',
      colorScheme: 'olaggYellow',
      status: 'error',
      description: error.errors,
      position: 'bottom-right'
    });
  }

  const createServer = async (data: CreateCardDeckServerData, callback?: () => void) => {
    return await fetcher(AdminCardDecksServersEndpoints.create(deckId, { discordServer: data }))
      .then(() => {
        success_toast('Servidor de Discord agregado con éxito');
        response.mutate();
        callback?.();
      })
      .catch((error: any) => {
        error_toast(error);
      })
  }

  const updateServer = async (serverId: string | number, data: Partial<CreateCardDeckServerData>, callback?: () => void) => {
    return await fetcher(AdminCardDecksServersEndpoints.update(deckId, serverId, { discordServer: data }))
      .then(() => {
        success_toast('Servidor de Discord actualizado con éxito');
        response.mutate();
        callback?.();
      })
      .catch((error: any) => {
        error_toast(error);
      })
  }

  const deleteServer = async (serverId: string | number) => (
    fetcher(AdminCardDecksServersEndpoints.delete(deckId, serverId))
      .then(() => {
        success_toast('Servidor de Discord eliminado con éxito');
        response.mutate();
      })
      .catch((error: any) => {
        error_toast(error);
      })
  )

  const find = (serverId: string | number) => {
    fetcher(AdminCardDecksServersEndpoints.show(deckId, serverId))
      .then(res => setServer(res.discordServer))
  }

  return {
    ...response,
    server,
    find,
    createServer,
    updateServer,
    deleteServer,
  }
} 